import { withInstall } from '@lit-element/utils'
import PopoverTip from './src/tooltip.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtPopoverTip: SFCWithInstall<typeof PopoverTip> =
  withInstall(PopoverTip)
export * from './src/arrow'
export * from './src/content'
export * from './src/root'
export * from './src/tooltip'
export * from './src/trigger'
export * from './src/constants'

export default LtPopoverTip
